import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/marmalade';

import React from 'react';
import { LISTING_HEAP_IDS } from '../../../../constants';
import {
    EventActionType,
    useEventDispatchContext,
    useScrollDispatch,
} from '../../../../contexts';

export const ScrollToDateButton: React.FC<{}> = () => {
    const scrollTo = useScrollDispatch();
    const dispatch = useEventDispatchContext();
    return (
        <Button
            data-testid="scroll-to-date-button"
            variant="primary"
            onClick={() => {
                scrollTo({ action: 'scroll', target: 'date-selector' });
                dispatch({
                    type: EventActionType.setSelectedEvent,
                    payload: {
                        selectedDate: true,
                    },
                });
            }}
            data-heap-id={LISTING_HEAP_IDS.TIMED_ENTRY_ANCHOR_BUTTON_CLICK}
            size="block"
        >
            {gettext('Select tickets')}
        </Button>
    );
};
